"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProgramEndpoints = createProgramEndpoints;
/**
 * Etkinlik programı: konuşmacılar, konuşmacı bağlantıları ve ajanda.
 */
function createProgramEndpoints(client) {
    return {
        speakers: {
            list: (eventId) => client.call('/events/{eventId}/speakers', 'get', { path: { eventId } }),
            manageList: (eventId) => client.call('/events/{eventId}/speakers/manage', 'get', { path: { eventId } }),
            create: (eventId, input) => client.call('/events/{eventId}/speakers', 'post', { path: { eventId }, body: input }),
            update: (eventId, speakerId, input) => client.call('/events/{eventId}/speakers/{speakerId}', 'patch', {
                path: { eventId, speakerId },
                body: input,
            }),
            remove: (eventId, speakerId, confirm) => client.call('/events/{eventId}/speakers/{speakerId}', 'delete', {
                path: { eventId, speakerId },
                query: (confirm === undefined ? {} : { confirm }),
            }),
            reorder: (eventId, input) => client.call('/events/{eventId}/speakers/reorder', 'post', {
                path: { eventId },
                body: input,
            }),
            requestLink: (eventId, speakerId, input) => client.call('/events/{eventId}/speakers/{speakerId}/link', 'post', {
                path: { eventId, speakerId },
                body: input,
            }),
            removeLink: (eventId, speakerId) => client.call('/events/{eventId}/speakers/{speakerId}/link', 'delete', {
                path: { eventId, speakerId },
            }),
        },
        publicSpeakers: {
            speakers: (slug) => client.call('/public/events/{slug}/speakers', 'get', { path: { slug } }),
            agenda: (slug) => client.call('/public/events/{slug}/agenda', 'get', { path: { slug } }),
            /** Konuşmacı sayfası (ekran 29) — taslak/`invite_only` etkinlikte 404. */
            speaker: (slug, speakerId) => client.call('/public/events/{slug}/speakers/{speakerId}', 'get', {
                path: { slug, speakerId },
            }),
        },
        speakerLinks: {
            list: () => client.call('/users/me/speaker-links', 'get', {}),
            respond: (speakerId, input) => client.call('/users/me/speaker-links/{speakerId}/respond', 'post', {
                path: { speakerId },
                body: input,
            }),
            remove: (speakerId) => client.call('/users/me/speaker-links/{speakerId}', 'delete', { path: { speakerId } }),
        },
        agenda: {
            view: (eventId) => client.call('/events/{eventId}/agenda', 'get', { path: { eventId } }),
            sessions: (eventId) => client.call('/events/{eventId}/agenda/sessions', 'get', { path: { eventId } }),
            createSession: (eventId, input) => client.call('/events/{eventId}/agenda/sessions', 'post', {
                path: { eventId },
                body: input,
            }),
            updateSession: (eventId, sessionId, input) => client.call('/events/{eventId}/agenda/sessions/{sessionId}', 'patch', {
                path: { eventId, sessionId },
                body: input,
            }),
            removeSession: (eventId, sessionId) => client.call('/events/{eventId}/agenda/sessions/{sessionId}', 'delete', {
                path: { eventId, sessionId },
            }),
        },
    };
}
//# sourceMappingURL=program.js.map